
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { FC, useState } from "react";
import DIContainer from "../DI/DIContainer";
import DIServices from "../DI/DIServices";
import { ILogger } from "../Utils/Logger";
import { IEnvironment } from "../config/Environments";

/** The AppContext should keep ONLY the app-session-wide objects and settings */
export interface IAppContext {
    isInDebugMode: boolean;
    environment: IEnvironment;
    correlationId: string;
    setCorrelationId: (correlationId: string) => void;
    appInsights: ApplicationInsights;
    logger: ILogger;

}

export interface AppContextProps {
    isInDebugMode?: boolean;
    environment: IEnvironment;
    correlationId: string;
    appInsights: ApplicationInsights;
    logger: ILogger;
    children?: React.ReactNode
}

const AppContext = DIContainer.createContext(DIServices.AppContext);
export const useAppContext = () => DIContainer.use<IAppContext>(DIServices.AppContext);

const AppContextProvider: FC<AppContextProps> = (props) => {

    const { children, environment, correlationId: corrIdProp, appInsights, logger, isInDebugMode } = props;

    const [correlationId, setCorrelationId] = useState<string>(corrIdProp)

    const appContext: IAppContext = {
        isInDebugMode: isInDebugMode != null ? isInDebugMode : false,
        environment: environment,
        correlationId: correlationId,
        setCorrelationId: setCorrelationId,
        appInsights: appInsights,
        logger: logger
    }
    return (
        <AppContext.Provider value={appContext}>
            {children}
        </AppContext.Provider>
    )
}

export default AppContextProvider

